import {
  GET_PAYMENT_SERVICE_CONF,
  SET_PAYMENT_SERVICE_CONF,
  PAYMENT_SERVICE_CONF,
  SET_PAYMENT_SERVICE_DATA_RESULT,
  PAYMENT_SERVICE_RESULT,
  SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA,
  TELCEL_PREPAGO_PAYMENT_SERVICE_DATA,
  SET_OCR_SCANNER_DATA,
  OCR_SCANNER_DATA,
  SET_PAYMENT_SERVICE_CONTACTS,
  PAYMENT_SERVICE_CONTACTS,
  SET_NUMBER_CONTACTS,
  SET_CONTACT_INFO,
  SET_CREDIT_CARD_INFO,
  GET_PAYMENT_SERVICE_CONTACTS,
  GET_FAVORITE_CONTACTS,
  GET_FAVORITE_CONTACTS_SUCESS,
  GET_FAVORITE_CONTACTS_ERROR,
  ADD_CONTACT_TO_FAVORITES,
  ADD_CONTACT_TO_FAVORITES_SUCESS,
  ADD_CONTACT_TO_FAVORITES_ERROR,
  GET_GO_TO_MICROAPPADELANTO,

  ///// Contacts recent
  GET_RECENT_CONTACTS,
  GET_RECENT_CONTACTS_SUCESS,
  GET_RECENT_CONTACTS_ERROR,
  ADD_CONTACT_TO_RECENTS,
  ADD_CONTACT_TO_RECENTS_SUCESS,
  ADD_CONTACT_TO_RECENTS_ERROR,

  /// Telcel
  GET_AMOUNT_OF_TELCEL_POSPAGO,
  GET_AMOUNT_OF_TELCEL_POSPAGO_SUCESS,
  GET_AMOUNT_OF_TELCEL_POSPAGO_ERROR,

  GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT,
  GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT_SUCCESS,

  /// get user info
  GET_USER_INFO,
  GET_USER_INFO_SUCESS,
  GET_USER_INFO_ERROR,

  /// get user info lite
  GET_USER_INFO_LITE,
  GET_USER_INFO_LITE_SUCESS,
  GET_USER_INFO_LITE_ERROR,

  /// payment methods
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_SUCESS,
  GET_PAYMENT_METHODS_ERROR,

  /// commission rules
  GET_COMMISSION_RULES,
  GET_COMMISSION_RULES_SUCESS,
  SET_SELECTED_CHIP_VALUES,
  SET_SELECTED_CHIP_VALUES_SUCESS,
  GET_COMMISSION_INFO,
  GET_COMMISSION_INFO_SUCESS,
  GET_PLANS,
  GET_PLANS_SUCCESS,
  GET_PLANS_ERROR,
  EXIST_CARD_SEARS,
  EXIST_CARD_SEARS_SUCCESS,
  EXIST_CARD_SEARS_ERROR,
  GET_PLANS_CARD_SEARS,
  GET_PLANS_CARD_SEARS_SUCCESS,
  GET_COORDINATES,
  SET_COORDINATES,
  GET_TRACK_ID,
  GET_TRACK_ID_SUCCESS,
  SET_TRACK_STEPS,
  SET_TRACK_STEPS_SUCCESS,
  GET_ACTIVE_FROM_URL,
  GET_CAN_ENCRYPT,
  GET_CAN_MANAGE_FAVORITES,
  GET_CAN_FAVORITE_TOOLTIP,
  SEND_SERVICEID,
  GET_HAS_CREDIT_FROM_URL,
  GET_PHONE_NUMBER,
  ORIGIN_OF_PAYMENT,
  EXECUTE_TAGGEO,
  SEND_ISCLAROSOCIO,
  GET_MESSENGER_SERVICE,
  GET_MESSENGER_SERVICE_SUCCESS,
  GET_MESSENGER_SERVICE_ERROR,
  GET_MESSENGER_SERVICE_SEARS,
  GET_MESSENGER_SERVICE_SEARS_SUCCESS,
  GET_MESSENGER_SERVICE_SEARS_ERROR,
  GET_PARAMS_FROM_URL,
  GET_BUNDLE_VERSION_FROM_URL,
  GET_BUNDLE_ID_FROM_URL,
  SHOW_NEW_OFFER_TELCEL,
  SHOW_CAN_COOKIES,
  GET_TELCEL_LINE_INFORMATION,
  GET_TELCEL_LINE_INFORMATION_SUCCESS,
  GET_TELCEL_LINE_INFORMATION_ERROR,
  SET_PAYMENT_METHOD,
  GET_PAYMENT_AMOUNT_FROM_URL,
  GET_PRODUCT_ID_FROM_URL,
  SET_CODE_ERROR,
  GET_CODE_ERROR,
  SET_RELOAD_INFO_AFTER_ADDING_CARD,
  SET_IS_ANONIMOUS,
  SET_IS_TEMPORAL_CLARO_ID,
  SET_ADD_CARD_FORM_DATA,
  GET_APP_SYNC,
  GET_APP_SYNC_SUCCESS,
  GET_APP_SYNC_ERROR,
  SET_ADVANCEMT_PAY_METHOD,
  SET_SHOW_ADVANCEMT_MINI_BANNER,
  SET_IS_CONTAINER_TELCEL,
  SET_CVV_FOR_ANONIMOUS
} from "../actions";

const initialState = {
  isLoading: false,
  isLoadingGetRecentContacts: false,
  isloadingGetAmountTelcelPospago: false,
  isLoadingGetPaymentMethods: false,
  isLoadingCommisSionRules: false,
  isLoadingCommissionInfo: false,
  isLoadingGetPlans: false,
  isLoadingExistCardSears: false,
  isLoadingGetPlansCardSears: false,
  responseCheckBalancefrom: "",
  isLoadingGetCoordinates: false,
  isLoadingGetTrackId: false,
  isLoadingTrackSteps: false,
  isLoadingGetLineTelcelInformation: false,
  isLoadigGetScheduleTelcelBillPayments: false,
  reloadInfoAfterAddingCard: false,
  isAnonimous: false,
  canManageFavorites:false,
  canFavoriteTooltip:false,
  isTemporalClaroId: false,
  addCardFormData: {},
  isLoadingAppSync: false,
  appSyncValues: {},
  userInfoLite :  {},
  setAdvancementPayMethodValue: false,
  showAdvancementMiniBanner: false,
  isContainerTelcel: false,
  cvvForAnonimous: ""
};

export default (
  state = initialState,
  {
    type,
    payload,
    userInfo,
    userInfoLite,
    favoriteContacts,
    error,
    recentContacts,
    amountTelcelPospago,
    paymentMethods,
    commissionRules,
    selectedChipValues,
    plans,
    existCardSears,
    errorExistCardSears,
    plansCardSears,
    contactInfo,
    cardInfo,
    errorPaymentMethods,
    errorCheckBalance,
    trackId,
    coordinates,
    activeN2,
    canEncrypt,
    canManageFavorites,
    canFavoriteTooltip,
    canSendServiceId,
    hasCredit,
    lineNumber,
    originOfPayment,
    canSendClaroSocioValue,
    canShowCanCookies,
    messages,
    errorPlans,
    params,
    bundleVersion,
    bundleId,
    canShowNewOfferTelcel,
    lineTelcelInformation,
    setPaymentMethodInfo,
    codeError,
    searsMessages,
    scheduleTecelContract,
    appSyncValues,
    appSyncError
  }
) => {
  switch (type) {
    case SET_CVV_FOR_ANONIMOUS:
      return {
        ...state,
        cvvForAnonimous: payload
      }
      
    case SET_IS_CONTAINER_TELCEL:
      return {
        ...state,
        isContainerTelcel: payload
      }
      
    case SET_ADD_CARD_FORM_DATA:
      return {
        ...state,
        addCardFormData: payload
      }
    
    case SET_IS_TEMPORAL_CLARO_ID:
      return {
        ...state,
        isTemporalClaroId: payload,
      }; 
    case SET_IS_ANONIMOUS:
      return {
        ...state,
        isAnonimous: payload,
      }; 
    case SET_RELOAD_INFO_AFTER_ADDING_CARD:
      return {
        ...state,
        reloadInfoAfterAddingCard: payload,
      };  
    case GET_PAYMENT_SERVICE_CONTACTS:
      return {
        ...state,
        isLoading: true,
      };
    case GET_PAYMENT_SERVICE_CONF:
      return {
        ...state,
      };
    case SET_PAYMENT_SERVICE_CONF:
      return {
        ...state,
        [PAYMENT_SERVICE_CONF]: {
          ...payload,
        },
      };
    case SET_PAYMENT_SERVICE_DATA_RESULT:
      return {
        ...state,
        [PAYMENT_SERVICE_RESULT]: {
          ...payload,
        },
      };
    case SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA:
      return {
        ...state,
        [TELCEL_PREPAGO_PAYMENT_SERVICE_DATA]: {
          ...payload,
        },
      };
    case SET_OCR_SCANNER_DATA:
      return {
        ...state,
        [OCR_SCANNER_DATA]: {
          ...payload,
        },
      };
    case SET_NUMBER_CONTACTS:
      return {
        ...state,
        [SET_NUMBER_CONTACTS]: payload,
      };
    case SET_CONTACT_INFO:
      return {
        ...state,
        contactInfo,
      };
    case SET_CREDIT_CARD_INFO:
      return {
        ...state,
        cardInfo,
      };
    case SET_PAYMENT_SERVICE_CONTACTS:
      return {
        ...state,
        [PAYMENT_SERVICE_CONTACTS]: {
          ...payload,
        },
        isLoading: false,
      };

    case GET_FAVORITE_CONTACTS:
      return {
        ...state,
        isLoading: true,
      };

    case GET_FAVORITE_CONTACTS_SUCESS:
      return {
        ...state,
        favoriteContacts,
        isLoading: false,
      };

    case GET_FAVORITE_CONTACTS_ERROR:
      return {
        ...state,
        error,
        isLoading: false,
      };

    case ADD_CONTACT_TO_FAVORITES:
      return {
        ...state,
      };

    case ADD_CONTACT_TO_FAVORITES_SUCESS:
      return {
        ...state,
      };

    case ADD_CONTACT_TO_FAVORITES_ERROR:
      return {
        ...state,
        error,
      };
    case GET_RECENT_CONTACTS:
      return {
        ...state,
        isLoadingGetRecentContacts: true,
      };

    case GET_RECENT_CONTACTS_SUCESS:
      return {
        ...state,
        recentContacts,
        isLoadingGetRecentContacts: false,
      };

    case GET_RECENT_CONTACTS_ERROR:
      return {
        ...state,
        error,
        isLoadingGetRecentContacts: false,
      };

    case ADD_CONTACT_TO_RECENTS:
      return {
        ...state,
      };

    case ADD_CONTACT_TO_RECENTS_SUCESS:
      return {
        ...state,
      };

    case ADD_CONTACT_TO_RECENTS_ERROR:
      return {
        ...state,
        error,
      };
    /// Telcel
    case GET_AMOUNT_OF_TELCEL_POSPAGO:
      return {
        ...state,
        isloadingGetAmountTelcelPospago: true,
      };

    case GET_AMOUNT_OF_TELCEL_POSPAGO_SUCESS:
      return {
        ...state,
        amountTelcelPospago,
        isloadingGetAmountTelcelPospago: false,
        responseCheckBalancefrom: "success",
      };

    case GET_AMOUNT_OF_TELCEL_POSPAGO_ERROR:
      return {
        ...state,
        errorCheckBalance,
        isloadingGetAmountTelcelPospago: false,
        responseCheckBalancefrom: "error",
      };

    case GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT:
      return {
        ...state,
        isLoadigGetScheduleTelcelBillPayments: true,
      };

    case GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT_SUCCESS:
      return {
        ...state,
        scheduleTecelContract,
        isLoadigGetScheduleTelcelBillPayments: false,
      };
    // user info
    case GET_USER_INFO:
      return {
        ...state,
      };
    case GET_USER_INFO_SUCESS:
      return {
        ...state,
        userInfo,
      };
    case GET_USER_INFO_ERROR:
      return {
        ...state,
        isLoadingGetUserInfo:false
      };
    // user info lite
    case GET_USER_INFO_LITE:
      return {
        ...state,
        isLoadingGetUserInfoLite: true
      };
    case GET_USER_INFO_LITE_SUCESS:
      return {
        ...state,
        userInfoLite,
        isLoadingGetUserInfoLite: false
      };
    case GET_USER_INFO_LITE_ERROR:
      return {
        ...state,
        isLoadingGetUserInfoLite: false
      };
    // payment methods
    case GET_PAYMENT_METHODS:
      return {
        ...state,
        isLoadingGetPaymentMethods: true,
      };
    case GET_PAYMENT_METHODS_SUCESS:
      return {
        ...state,
        paymentMethods,
        isLoadingGetPaymentMethods: false,
      };
    case GET_PAYMENT_METHODS_ERROR:
      return {
        ...state,
        errorPaymentMethods,
        isLoadingGetPaymentMethods: false,
      };
    // commission rules
    case GET_COMMISSION_RULES:
      return {
        ...state,
        isLoadingCommisSionRules: true,
      };
    case GET_COMMISSION_RULES_SUCESS:
      return {
        ...state,
        commissionRules,
        isLoadingCommisSionRules: false,
      };
    case SET_SELECTED_CHIP_VALUES:
      return {
        ...state,
      };
    case SET_SELECTED_CHIP_VALUES_SUCESS:
      return {
        ...state,
        selectedChipValues,
      };

    // commission rules
    case GET_COMMISSION_INFO:
      return {
        ...state,
        isLoadingCommisSionRules: true,
        isLoadingCommissionInfo: true,
      };
    case GET_COMMISSION_INFO_SUCESS:
      return {
        ...state,
        commissionInfo,
        isLoadingCommissionInfo: false,
      };
    // plans
    case GET_PLANS:
      return {
        ...state,
        isLoadingGetPlans: true,
      };
    case GET_PLANS_SUCCESS:
      return {
        ...state,
        plans,
        isLoadingGetPlans: false,
      };
    case GET_PLANS_ERROR:
      return {
        ...state,
        errorPlans,
        isLoadingGetPlans: false,
      };

    // exist card sears
    case EXIST_CARD_SEARS:
      return {
        ...state,
        isLoadingExistCardSears: true,
      };
    case EXIST_CARD_SEARS_SUCCESS:
      return {
        ...state,
        existCardSears,
        isLoadingExistCardSears: false,
      };

    case EXIST_CARD_SEARS_ERROR:
      return {
        ...state,
        errorExistCardSears,
        isLoadingExistCardSears: false,
      };
    // plans card sears
    case GET_PLANS_CARD_SEARS:
      return {
        ...state,
        isLoadingGetPlansCardSears: true,
      };
    case GET_PLANS_CARD_SEARS_SUCCESS:
      return {
        ...state,
        plansCardSears,
        isLoadingGetPlansCardSears: false,
      };
    case GET_COORDINATES:
      return {
        ...state,
        isLoadingGetCoordinates: true,
      };
    case SET_COORDINATES:
      return {
        ...state,
        coordinates,
        isLoadingGetCoordinates: false,
      };
    case GET_TRACK_ID:
      return {
        ...state,
        isLoadingGetTrackId: true,
      };
    case GET_TRACK_ID_SUCCESS:
      return {
        ...state,
        trackId,
        isLoadingGetTrackId: false,
      };
    case SET_TRACK_STEPS:
      return {
        ...state,
        isLoadingTrackSteps: true,
      };
    case SET_TRACK_STEPS_SUCCESS:
      return {
        ...state,
        response,
        isLoadingTrackSteps: false,
      };
    case GET_ACTIVE_FROM_URL:
      return {
        ...state,
        activeN2,
      };
    case GET_PHONE_NUMBER:
      return {
        ...state,
        lineNumber,
      };
    case GET_PARAMS_FROM_URL:
      return {
        ...state,
        params,
      };
    case GET_BUNDLE_VERSION_FROM_URL:
      return {
        ...state,
        bundleVersion,
      };
      case GET_BUNDLE_ID_FROM_URL:
        return {
          ...state,
          bundleId,
        };
    case ORIGIN_OF_PAYMENT:
      return {
        ...state,
        originOfPayment,
      };
    case GET_CAN_ENCRYPT:
      return {
        ...state,
        canEncrypt,
      };
      case GET_CAN_MANAGE_FAVORITES:
        return{
          ...state,
          canManageFavorites,
        };
        case GET_CAN_FAVORITE_TOOLTIP:
        return{
          ...state,
          canFavoriteTooltip,
        };
        case GET_GO_TO_MICROAPPADELANTO:
          return {
            ...state,
            goToMicroappAdelanto: payload,
          };
    case SEND_SERVICEID:
      return {
        ...state,
        canSendServiceId,
      };
    case GET_HAS_CREDIT_FROM_URL:
      return {
        ...state,
        hasCredit,
      };
    case EXECUTE_TAGGEO:
      return {
        ...state,
      };
    case SEND_ISCLAROSOCIO:
      return {
        ...state,
        canSendClaroSocioValue,
      };
    case SHOW_CAN_COOKIES:
      return {
        ...state,
        canShowCanCookies
      }
    case GET_MESSENGER_SERVICE:
      return {
        ...state,
        isLoading: true,
      };
    case GET_MESSENGER_SERVICE_SUCCESS:
      return {
        ...state,
        messages,
        isLoading: false
      }
    case GET_MESSENGER_SERVICE_ERROR:
      return {
        ...state,
        error,
        isLoading: false,
      }
      case GET_MESSENGER_SERVICE_SEARS:
        return {
          ...state,
          isLoading: true,
        };
      case GET_MESSENGER_SERVICE_SEARS_SUCCESS:
        return {
          ...state,
          searsMessages,
          isLoading: false
        }
      case GET_MESSENGER_SERVICE_SEARS_ERROR:
        return {
          ...state,
          error,
          isLoading: false,
        }
    case SHOW_NEW_OFFER_TELCEL:
      return {
        ...state,
        canShowNewOfferTelcel
      }
    case GET_TELCEL_LINE_INFORMATION:
      return {
        ...state,
        isLoadingGetLineTelcelInformation: true
      }
    case GET_TELCEL_LINE_INFORMATION_SUCCESS:
      return {
        ...state,
        lineTelcelInformation,
        isLoadingGetLineTelcelInformation: false,
      }
    case GET_TELCEL_LINE_INFORMATION_ERROR:
      return {
        ...state,
        error,
        isLoadingGetLineTelcelInformation: false,
      }
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        setPaymentMethodInfo: payload,
      }; 
    case GET_PAYMENT_AMOUNT_FROM_URL:
      return {
        ...state,
        getPaymentAmountFromUrl: payload,
      };
    case GET_PRODUCT_ID_FROM_URL:
      return {
        ...state,
        getProductIdFromUrl: payload,
      };
    case SET_CODE_ERROR:
        return {
          ...state,
          codeError: codeError,
        }; 
    case GET_CODE_ERROR:
        return {
          ...state,
          error,
          codeError: codeError,
        }
    case GET_APP_SYNC:
      return {
        ...state,
        isLoadingAppSync: true,
      }
    case GET_APP_SYNC_SUCCESS:
      return {
        ...state,
        appSyncValues,
        isLoadingAppSync: false,
      }
    case GET_APP_SYNC_ERROR:
      return {
        ...state,
        appSyncError,
        isLoadingAppSync: false,
      }
    case SET_ADVANCEMT_PAY_METHOD:
      return {
        ...state,
        setAdvancementPayMethodValue: payload,
      }
    case SET_SHOW_ADVANCEMT_MINI_BANNER:
      return {
        ...state,
        showAdvancementMiniBanner: payload,
      }
    default:
      return state;
  }
};
